export const FLAGS = Object.freeze({
  BS_DEBUG_MODE: 'bs-debug-mode',
  ACD_12446: 'bs_12446_order_module_ui_update',
  ACD_12337: 'bs_product_new_ui',
  ACD_13671: 'bs_13671_set_default_POS_sync_new_product',
  ACD_11119_HIDDEN_PRODUCT_TRASH_TAB_COVA_GREENLINE:
    'acd-11119-hidden-product-tab-cova-greenline',
  BS_FULFILLMENT_POLLING: 'bs_fulfillment_polling',
  BS_ENABLE_COVA_PRODUCT: 'bs-enable-cova-product',
  BS_FILTER_DATE_DEFAULT_YESTERDAY: 'bs_filter_date_default_yesterday',
  BS_ACD_11142: 'bs_11142_cova_product_sale_price_edit',
  BS_11801: 'bs_11801_set_order_note_to_public',
  BS_420: 'bs_420_no_update_warning',
  BS_14588: 'bs_14588_add_cloud_service_options_onboard_pos',
  BS_14439: 'bs_14439_christmas_holiday_no_update_warning',
  BS_13624: 'bs_13624_budsense_integration',
  BS_14173: 'bs_14173_thank_giving_no_update_warning',
  BS_11773: 'bs_11773_pickup_customized_time_slot',
  BS_11774: 'bs_11774_curbside_customized_time_slot',
  BS_13118: 'bs_13118_canada_post_on_strike_warning',
  BS_13549: 'bs_13549_Canada_day_no_update_warning',
  BS_14098: 'bs_14098_change_filter_criteria_order',
  BS_13369: 'bs_13369_nmi_integration',
  BS_13994: 'bs_13994_paramount_integration',
  BS_13857: 'bs_13857_dynamic_canada_post_service_option',
  BS_14316: 'bs_14316_location_specific_payment_method',
  ACD_11584: 'bs_11584_delivery_date_only',
  ACD_11582: 'bs_11582_ASAP_slot_option',
  ACD_11589: 'bs_11589_ASAP_last_order_time',
  ACD_12991: 'bs_12991_location_setting_ui_update',
  ACD_14785: 'bs_14785_disable_fulfillment_module',
  ACD_14885: 'bs_14885_hide_product_data_source',
  COMBINE_TAX_LINE_BY_LABEL: 'combine-tax-line-with-the-same-label-in-receipt',
  // TODO: replace placeholder with real bs_<jiraId>_control_panel key once known
  CONTROL_PANEL: 'bs_control_panel',
  SHOW_CREATE_WORKSPACE_BUTTON: 'bs-show-create-workspace-button',
  BS_ONBOARD_AUTO_CREATE_PANTRY_SITE: 'bs-onboard-auto-create-pantry-site',
  BS_POS_P3_NEW_UI: 'bs-pos-p3-new-ui',
  ALLOW_DELETE_CANFLEET_CONNECTION: 'allow-delete-canfleet-connection',
  ACD_15069: 'bs-15069-allow-edit-footer-text-in-order-email',
  BS_PANTRY_EMAIL_MARKETING: 'bs-pantry-email-marketing',
  // Value spelling ("converstation") is intentional — it must match the
  // GrowthBook flag key exactly. Gates the dashboard Conv. Rate / Total
  // Sessions KPI cards.
  BS_PANTRY_DASHBOARD_CONVERSION_RATE: 'bs-pantry-dashboard-converstation-rate',
  // Gates the "Last Seen" column in the pantry customer list.
  BS_PANTRY_CUSTOMER_LAST_SEEN: 'bs-pantry-customer-last-seen',
  // Gates the extended (5-sub-tab) Customer profile Behavior UI. Off = the
  // current flat widget grid; on = the new sub-tabbed layout. Mirrored in
  // pantry-features `hooks/useCustomerBehaviorExtends.ts`.
  BS_PANTRY_CUSTOMER_BEHAVIOR_EXTENDS: 'bs-pantry-customer-behavior-extends',
  // Gates the Product Page Score UI (sidebar card, SEO checklist, list column).
  // Mirrored in pantry-features `hooks/useProductPageScore.ts`.
  BS_PANTRY_PRODUCT_PAGE_SCORE: 'bs-pantry-product-page-score',
  BS_ENABLED_HUBSPOT: 'bs-enabled-hubspot',
  BS_ENABLE_CAMPAIGN: 'bs-enable-campaign',
  BS_ENABLE_SEGMENT: 'bs-enable-segment',
  // Full Campaign Builder (Email type, Template / Audience steps, reminder
  // emails). Mirrored in pantry-features `hooks/useEnableCampaignUplift.ts`.
  BS_ENABLE_CAMPAIGN_UPLIFT: 'bs-enable-campaign-uplift',

  // Flags for CS
  CS_7743: 'cs-7743-warning-redirect-out',
  CS_CSP_7619: 'cs-7589-custom-audio-notification',
  CS_8101: 'ticket-system',
  CS_8063: 'cs_8063_coupon_limit',
  CS_8181: 'cs_8181_new_promotion_module',
  CS_8598_EMAIL_MARKETING: 'CS_8598_email_marketing',
  CS_9035: 'cs_9035_notification',

  // CF
  CF_1844: 'cf-1828-config-late-night-hours',
  CF_1997: 'cf-1997-communication-hub',
  CF_2001: 'cf-2001-breadstack-homepage',
  CF_2258: 'cfd-2258-location-setting-enhancements',
})
